import * as React from "react";

function SvgToText({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M9.446 17.397l.084.073 2 2c.026.025.05.052.071.081l-.07-.081a.77.77 0 01.133.182l.014.026a.94.94 0 01.034.085l.006.019a.776.776 0 01.024.331l-.007.035c-.005.025-.01.05-.018.073l-.012.036-.028.067-.019.036a.774.774 0 01-.042.068l-.013.018-.01.012-.063.072-2 2a.749.749 0 01-1.133-.976l.073-.084.718-.72H3a.75.75 0 01-.102-1.493L3 19.25h6.189l-.72-.72a.75.75 0 01-.072-.976l.073-.084a.75.75 0 01.976-.073zM19 2.25a2.75 2.75 0 012.745 2.582L21.75 5v13a2.75 2.75 0 01-2.582 2.745L19 20.75h-4.3a.75.75 0 01-.102-1.493l.102-.007H19a1.25 1.25 0 001.244-1.122L20.25 18V5a1.25 1.25 0 00-1.122-1.244L19 3.75H5a1.25 1.25 0 00-1.244 1.122L3.75 5v11.209a.75.75 0 01-1.493.102l-.007-.102V5a2.75 2.75 0 012.582-2.745L5 2.25h14zm-7 8a.75.75 0 01.102 1.493L12 11.75H7a.75.75 0 01-.102-1.493L7 10.25h5zm5-4a.75.75 0 01.102 1.493L17 7.75H7a.75.75 0 01-.102-1.493L7 6.25h10z"
        />
      </g>
    </svg>
  );
}

export default SvgToText;
